<template>
  <div
    :id="modalId"
    :class="classes"
    :style="this.styles"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog">
      <div v-if="data" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('adm.customer.edit-prod')}}</h5>
          <button type="button" class="close" @click="hide" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="save" class="form-horizontal">
          <div class="modal-body">
            <div class="form-body">
              <div class="form-group row">
                <label class="control-label text-right col-md-4 text-left-m"
                  >{{$tc('generic-str.name', 1)}}</label
                >
                <div class="col-md-6">
                  <input v-model="form.name" type="text" class="form-control" />
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label text-right col-md-4 text-left-m"
                  >{{$t('generic-str.type')}}</label
                >
                <div class="col-md-6">
                  <select-input
                    v-model="form.type"
                    :options="types"
                    :clearable="false"
                    @input="changeType"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label text-right col-md-4 text-left-m"
                  >{{$t('customer-component.route')}}</label
                >
                <div class="col-md-6">
                  <select-input
                    v-if="providers.length"
                    v-model="form.provider_id"
                    label="alias"
                    :reduce="(provider) => provider.id"
                    :options="providers"
                    :clearable="false"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="hide">
              {{$t('generic-str.cancel')}}
            </button>
            <button
              :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
              :disabled="isSending"
              type="submit"
              class="btn btn-primary"
            >
              {{$t('generic-str.save')}}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from '@/services/admin/product.service';
import ProviderService from '@/services/admin/provider.service';
import Modal from '@/mixins/Modal';
import SelectInput from '@/components/SelectInput.vue';

export default {
  mixins: [Modal],
  components: {
    SelectInput,
  },
  props: ['id'],
  data() {
    return {
      types: JSON.parse(process.env.VUE_APP_TYPES),
      routes: [],
      form: {
        name: '',
        type: '',
        provider_id: '',
      },
      isSending: false,
    };
  },
  created() {
    this.form.type = this.types[0];
    this.changeType();
  },
  methods: {
    changeType() {
      this.providers = [];
      this.form.provider_id = '';
      this.fetchProviders();
    },
    fetchProviders() {
      ProviderService.getProviders({
        type: this.form.type,
      }).then(
        (response) => {
          this.providers = response;
        },
        (error) => {
          this.content = error;
        },
      );
    },
    save() {
      this.isSending = true;
      ProductService.updateProduct(this.form).then(
        () => {
          this.hide();
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: this.$t('adm-component.saved'),
            type: 'success',
          });
          this.$emit('sent');
          this.isSending = false;
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
            content: error.message,
            type: 'danger',
          });
          this.isSending = false;
        },
      );
    },
  },
};
</script>
